import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=8584b4f8&scoped=true&"
import script from "./SelectDropdown.vue?vue&type=script&lang=js&"
export * from "./SelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SelectDropdown.vue?vue&type=style&index=0&id=8584b4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8584b4f8",
  null
  
)

export default component.exports